/* Accessible LV accordions. Supports one-open and multiple-open groups. */
(function () {
  function getParts(button) {
    var row = button.closest('[data-lv-accordion-row], .lv-disclosure__row, .lv-how-to__row');
    return { row: row, panel: row && row.querySelector('[data-lv-accordion-panel]') };
  }

  function setOpen(button, panel, open) {
    if (!button || !panel) return;
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
  }

  function closeOthers(accordion, currentButton) {
    accordion.querySelectorAll('[data-lv-accordion-btn]').forEach(function (button) {
      if (button === currentButton) return;
      var parts = getParts(button);
      setOpen(button, parts.panel, false);
    });
  }

  function initAccordion(accordion) {
    if (accordion.dataset.lvAccordionReady === 'true') return;
    accordion.dataset.lvAccordionReady = 'true';
    accordion.addEventListener('click', function (event) {
      var button = event.target.closest('[data-lv-accordion-btn]');
      if (!button || !accordion.contains(button)) return;
      var parts = getParts(button);
      if (!parts.panel) return;
      var willOpen = button.getAttribute('aria-expanded') !== 'true';
      if (willOpen && accordion.dataset.lvAccordionMultiple !== 'true') closeOthers(accordion, button);
      setOpen(button, parts.panel, willOpen);
    });
  }

  function init(scope) {
    if (scope.matches && scope.matches('[data-lv-accordion]')) initAccordion(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-lv-accordion]').forEach(initAccordion);
  }

  function start() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var row = event.target.closest('[data-lv-accordion-row], .lv-disclosure__row, .lv-how-to__row');
    var button = row && row.querySelector('[data-lv-accordion-btn]');
    var panel = row && row.querySelector('[data-lv-accordion-panel]');
    if (button && panel) {
      var accordion = row.closest('[data-lv-accordion]');
      if (accordion && accordion.dataset.lvAccordionMultiple !== 'true') closeOthers(accordion, button);
      setOpen(button, panel, true);
    }
  });
})();
